/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";

export const FlagsPermissionHubToHub = {
  hub_menu_enable: new Rox.Flag(false),
  in_hub_list: new Rox.Flag(false),
  out_hub_list: new Rox.Flag(false),
  in_hub_create: new Rox.Flag(false),
  out_hub_create: new Rox.Flag(false)
};

export function initFlagsPermissionHubToHub() {
  // register flags with namespaces for better grouping
  Rox.register("featureHubToHub", FlagsPermissionHubToHub);
}
